import * as React from 'react';

export function RealtyValuation({ children }: React.PropsWithChildren<{}>) {
  return <div>{children}</div>;
}
